import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type {
  GetPublicWhiteLabelParams,
  GetPublicWhiteLabelResponse,
} from './get-white-label.types'

const getPublicWhiteLabel = async (
  params?: GetPublicWhiteLabelParams,
): Promise<GetPublicWhiteLabelResponse> => {
  const response = await apiClient.get<GetPublicWhiteLabelResponse>(
    '/v1/white-label',
    { params },
  )
  return response.data
}

export const useGetPublicWhiteLabel = (params?: GetPublicWhiteLabelParams) => {
  return useQuery({
    queryKey: ['public-white-label', params],
    queryFn: () => getPublicWhiteLabel(params),
  })
}
